import { capitalizeFirstLetter } from '@btime/helpers'
import { compose, find, prop, propEq } from 'ramda'
import { gql } from '@apollo/client'
import { usePermissionsChecker, useSessionPermission } from '@btime/react-session'

import { placesClient } from '../apollo/api'
import { toCamelCase } from './string'
import { useQuery } from '../apollo/_helpers/useQuery'

const QUERY = gql`
  query PlaceTypes {
    placeTypes(limit: 999999999) {
      id
      name
      namePlural
      key
      icon
    }
  }
`

export const usePlaceTypes = () => {
  const { data, ...state } = useQuery(QUERY, {
    client: placesClient,
    fetchPolicy: 'cache-first'
  })

  return [data?.placeTypes || [], state]
}

export const usePlaceTypesWithPermission = name => {
  const [types] = usePlaceTypes()
  const checkPermission = usePermissionsChecker()
  return types.filter(type => checkPermission([`${name}${formatPlaceTypePermission(type)}`]))
}

export const usePlaceTypePermission = (name, type) => {
  return useSessionPermission(`${name}${formatPlaceTypePermission(type)}`)
}

export const usePlaceTypeName = (type, plural = false) => {
  const [types] = usePlaceTypes()
  return compose(prop(plural ? 'namePlural' : 'name'), find(propEq('key', type)))(types || [])
}

export const formatPlaceTypePermission = placeType => {
  return compose(capitalizeFirstLetter, toCamelCase)(placeType?.key || placeType || '')
}
